import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { postShopifyAuthCallback } from '../components/API/shopify';
import LoadingBackdrop from '../components/LoadingBackdrop';

export default function ShopifyAuthRedirect() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  async function handleAppInstall() {
    setLoading(true);
    try {
      const searchParams = new URLSearchParams(window.location.search);
      let paramsObj = {};
      for (var key of searchParams.keys()) {
        paramsObj[key] = searchParams.get(key);
      }
      await postShopifyAuthCallback(paramsObj);
    } catch (error) {
      console.log('Error completing shopify auth url', error);
    }
    setLoading(false);
    history.push('/');
  }

  useEffect(() => {
    handleAppInstall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <LoadingBackdrop open={loading} />
    </div>
  );
}
